import { useLayout } from "pages/LayoutContext";
import React from "react";
import { Outlet } from "react-router-dom";
import companyLogo from "../assets/zakhealth-logo.svg";

const GuestLayout: React.FC = () => {
    const { clientLogo, clientName } = useLayout();
    const clientDetails = localStorage.getItem("clientDetails");
    return (
        <div className="min-h-screen flex flex-col bg-gray-50">
            {/* Header */}
            <header className="bg-white shadow-sm">
                <div className="max-w-7xl mx-auto px-4 py-3 flex justify-center items-center">
                    {clientLogo ? (
                        <img
                            src={clientLogo}
                            alt="Client Logo"
                            className="h-12 w-24 object-contain"
                        />
                    ) : clientName ? (
                        <span className="text-lg font-semibold text-gray-800">
                            {clientName}
                        </span>
                    ) : (
                        <img
                            src={companyLogo}
                            alt="Company Logo"
                            className="h-12 w-24 object-contain"
                        />
                    )}
                </div>
            </header>


            {/* Main content */}
            <main className="flex-1 max-w-6xl mx-auto w-full">
                <Outlet />
            </main>
        </div>
    );
};

export default GuestLayout;
